module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"tooltips":{"send":"Send","add":"Add","limitReached":"This text is too long, the limit has been reached"}},"es":{"tooltips":{"send":"Enviar","add":"Añadir","limitReached":"Este texto es muy largo, el limite ha sido alcanzado"}}}')
  delete Component.options._Ctor
}
